// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"71cc7118","377":"eb12a3bf","445":"87a172c2","457":"adac7dca","767":"70824719","842":"7c39ee56","960":"89b1a33a"}[chunkId] + ".chunk.js";
};